import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["Toast"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["NavBar"]),
      _createVNode(_component_router_view),
      _createVNode($setup["SiteFooter"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}